import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';

import { setBusinessUnit } from '../../actions/AuthActions';

import '../../stylesheets/pages/SignupIntentPage.less';

import Registry from '../../assets/images/onboard/intent-registry-image.svg';
import Website from '../../assets/images/onboard/intent-website-image.svg';
import Invites from '../../assets/images/onboard/intent-invites-image.svg';

import { isDesktop } from '../../lib/responsive';

export class SignupIntentPage extends Component {
  // This page is pre-auth.
  constructor(props) {
    super(props);
    this.handleSetProduct = this.handleSetProduct.bind(this);
  }

  handleSetProduct(businessUnit) {
    this.props.onSetProduct(businessUnit);
  }

  render() {
    const { businessUnit } = this.props;
    const headerText = isDesktop() ? 'What can we help you with first?' : 'What would you like to explore first?';
    return (
      <div className="signup-intent-page-v2">
        <Helmet
          style={[
            {
              type: 'text/css',
              cssText: ` html, .main-content {
                background: #e5eef7;
              }
              body {
                margin-bottom: 75px;
              }`
            }
          ]}
        />
        <a href="/" target="_self">
          <div className="zola-logo-hearts" />
        </a>
        <div className="container signup-intent__container">
          <div className="row">
            <div className="intent-title col-xs-12 text-center">{headerText}</div>
          </div>
          <div className="row signup-products-container">
            <div className="signup-product-row">
              <div className={`signup-product ${(businessUnit === 'REGISTRY') ? 'active' : ''}`}>
                <div className="inner-animation-wrapper">
                  <Link href="/onboard/new" className="product-container tag-signup-intent-registry" id="tag-signup-intent-registry">
                    <img className="product-image-container" src={Registry} alt="Signup for a Wedding Registry" />
                    <div className="signup-copy-container">
                      <h4 className="signup-product-title">Registry</h4>
                      <div className="signup-product-description">The easiest way to register for gifts <em>and</em> honeymoon funds in one place.</div>
                    </div>
                  </Link>
                </div>
              </div>
              <div className={`signup-product ${(businessUnit === 'WEDDING_WEBSITE') ? 'active' : ''}`}>
                <div className="inner-animation-wrapper">
                  <Link to="/wedding/onboard?product=WEDDING_WEBSITE" className="product-container tag-signup-intent-website" id="tag-signup-intent-website" onClick={() => this.handleSetProduct('WEDDING_WEBSITE')}>
                    <img className="product-image-container" src={Website} alt="Signup for a Wedding Registry" />
                    <div className="signup-copy-container">
                      <h4 className="signup-product-title">Wedding Website</h4>
                      <div className="signup-product-description">Free, beautiful designs you can customize in minutes. Online RSVP, too.</div>
                    </div>
                  </Link>
                </div>
              </div>
              <div className={`signup-product ${(businessUnit === 'INVITATIONS') ? 'active' : ''}`}>
                <div className="inner-animation-wrapper">
                  <Link to="/wedding/onboard?product=INVITATIONS" className="product-container tag-signup-intent-invites" id="tag-signup-intent-invites" onClick={() => this.handleSetProduct('INVITATIONS')}>
                    <img className="product-image-container" src={Invites} alt="Signup for a Wedding Registry" />
                    <div className="signup-copy-container">
                      <h4 className="signup-product-title">Invites &#43; Paper</h4>
                      <div className="signup-product-description">Gorgeous cards made to be personalized easily, all at friendly prices.</div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <a href="/" className="hidden-xs btn-link"><i className="zolaicon-chevron-left" /> Back</a>
        <div className="visible-xs mobile-back-footer">
          <a href="/"><i className="zolaicon-chevron-left" /></a>
        </div>
      </div>
    );
  }
}

SignupIntentPage.propTypes = {
  onSetProduct: PropTypes.func,
  businessUnit: PropTypes.oneOf(['REGISTRY', 'WEDDING_WEBSITE', 'INVITATIONS', 'WEDDING_CHECKLIST']),
};

const mapStateToProps = state => ({
  businessUnit: state.auth.businessUnit
});

const mapDispatchToProps = dispatch => ({
  onSetProduct: businessUnit => dispatch(setBusinessUnit(businessUnit)),
});

const SignupIntent = connect(
  mapStateToProps,
  mapDispatchToProps
)(SignupIntentPage);

export default SignupIntent;



// WEBPACK FOOTER //
// ./src/pages/preauth/SignupIntentPage.jsx